const state = {
  // 广点通推广目标
  promoted_object_type: 'PROMOTED_OBJECT_TYPE_APP_ANDROID',
  // 广点通选择的广告主
  advertiser_ids: [],
};
export default {
  state,
};
